import React from 'react'
import { ComponentWithElementProps } from '../types'

const Image = ({ element }: ComponentWithElementProps) => {
    return (
        <img src={`/download/${element.props.src}`} style={{ width: '100%', ...element.props, src: undefined }} alt="" />
    )
}

export default Image